module.exports = __webpack_public_path__ + "img/down.56a425aa.svg";